import { formatBytes } from "helpers/document_upload_helpers"

export class FileValidator {
  constructor({ allowedTypes, maxSize }) {
    this.allowedTypes = allowedTypes ? allowedTypes.split(",") : []
    this.maxSize = maxSize
  }

  validate(file) {
    if (!file) {
      return "Invalid file"
    }

    const typeError = this.#validateFileType(file)
    if (typeError) return typeError

    const sizeError = this.#validateFileSize(file)
    if (sizeError) return sizeError

    return null
  }

  #validateFileType(file) {
    if (!file.type) {
      return "Unable to determine file type"
    }

    if (this.allowedTypes.length && !this.allowedTypes.includes(file.type)) {
      return `File type not allowed`
    }
    return null
  }

  #validateFileSize(file) {
    if (typeof file.size !== 'number') {
      return "Unable to determine file size"
    }

    if (file.size > this.maxSize) {
      return `File too large. Must be less than ${formatBytes(this.maxSize)}`
    }
    return null
  }
}
